import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import CategoryList from "../../features/manageCategories/categoryList";
import CategoryTopbar from "../../features/manageCategories/topbar";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Switch,
  Toolbar,
  Tooltip,
} from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import AddCategory from "../../Modals/addCategory";
import AddSubCategory from "../../Modals/addSubCategory";
import {
  useUpdateCategoryMutation,
  useLazyGetSubCategoryQuery,
  useAddSubCategoryMutation,
  useUpdateSubCategoryMutation,
  useLazyDeleteCategoryQuery,
  useReorderingApiMutation,
} from "../../services/category";
import SearchBar from "../../components/SearchBar";
import { showError, showToast } from "../../constants/toasts";
import moment from "moment";
import SubCategoryDetails from "../../Modals/subCategoryDetails";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import { isValidInput } from "../../utils/validations";
import { getFromStorage } from "../../helpers/storage";
import { STORAGE_KEYS } from "../../constants/storageKeys";
import Pagination from "../../components/Panigation";
import { CATEGORY_TYPE } from "../../utils/enums";
import {
  closestCenter,
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { SortableItem } from "../../components/SortableItem";
import useTranslation from "../../hooks/traslation";
import Loader from "../../constants/Loader";

interface CategoryRow {
  _id: string;
  status: boolean;
  name: string;
  startPrice: string;
  createdAt: string;
  parentCategory: { name: string; _id: string };
}

const ViewCategory = () => {
  const navigate = useNavigate();
  const getLang = getFromStorage(STORAGE_KEYS.language);
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [image, setImage] = useState<string>("fddsfjhfgdsjhfsd");
  const [isStatusLoading, setIsStatusLoading] = useState(false);
  const [price, setPrice] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [name_ar, setName_ar] = useState<string>("");
  const [description_ar, setDescription_ar] = useState<string>("");
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [selectedId, setSelectedId] = useState<string>("");

  const [addSubCategory] = useAddSubCategoryMutation();
  const [updateSubCategory] = useUpdateCategoryMutation();
  const [deleteSubCategory] = useLazyDeleteCategoryQuery();
  const [getSubCategory] = useLazyGetSubCategoryQuery();
  const [reorderMethod] = useReorderingApiMutation();
  const [updateStatus] = useUpdateSubCategoryMutation();
  const [rows, setRows] = useState<CategoryRow[]>([]);
  const [openDetails, setOpenDetails] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const [totalCount, setTotalCount] = useState(10);
  const translate = useTranslation();

  const handleSubmit = async () => {
    setError(true);
    setIsFormLoading(true);
    const body = {
      name: name,
      parentId: id,
      startPrice: Number(price),
      name_ar: name_ar,
      ...(description ? { description: description } : {}),
      ...(description_ar ? { description_ar: description_ar } : {}),
    };

    if (selectedId) {
      try {
        const response = await updateSubCategory({
          body,
          id: selectedId,
        }).unwrap();
        if (response?.statusCode === 200) {
          getAllCategory();
          showToast(translate?.auth?.updatedSubCategory);
          setOpen(false);
          setName("");
          setPrice("");
          setName_ar("");
          setDescription_ar("");
          setDescription("");
        }
      } catch (error: any) {
        console.log("error>>: ", error?.data);
        showError(error?.data?.message || "");
      } finally {
        setIsFormLoading(false);
        getAllCategory();
      }
    } else {
      try {
        const response = await addSubCategory({
          data: { ...body, parentId: id || "" },
        }).unwrap();
        if (response?.statusCode === 200) {
          getAllCategory();
          showToast(translate?.auth?.addedSubCategory);
          setOpen(false);
          setName("");
          setDescription("");
          setPrice("");
          setName_ar("");
          setDescription_ar("");
        }
      } catch (error: any) {
        console.log("error>>: ", error?.data);
        showError(error?.data?.message || "");
      } finally {
        setIsFormLoading(false);
        getAllCategory();
      }
    }
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const getAllCategory = async () => {
    setIsLoading(true);
    setIsPageLoading(true);
    try {
      const response = await getSubCategory({
        parentId: id || "",
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      if (response?.statusCode === 200) {
        setTotalCount(response?.data?.totalCount || 10);
        setRows(
          response?.data?.list?.map(
            (data: { _id: string; categoryName: string }) => ({
              ...data,
              id: data?._id,
            })
          ) || []
        );
      }
    } catch (error) {
      showToast(translate?.auth?.failedToLoadSubCategory);
    } finally {
      setIsLoading(false);
      setIsPageLoading(false);
    }
  };

  const handleStatusChange = async (id: string, status: boolean) => {
    setIsStatusLoading(true);
    try {
      const body = {
        status: status,
      };
      const response = await updateStatus({
        id: id,
        body: body,
      }).unwrap();

      if (response.statusCode === 200) {
        showToast(
          status
            ? "Sub-Service Enable Successfully"
            : "Sub-Service Disabled Successfully"
        );
        setRows((prevRows) =>
          prevRows.map((row) => (row._id === id ? { ...row, status } : row))
        );
      } else {
        showError(translate?.auth?.failToUpdate);
      }
    } catch (error: any) {
      showError(error?.data?.message || translate?.auth?.failToUpdate);
    } finally {
      setIsStatusLoading(false);
      getAllCategory();
    }
  };

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const response = await deleteSubCategory({ id: selectedId }).unwrap();
      setIsLoading(false);

      if (response?.statusCode === 200) {
        showToast(translate?.auth?.successfullSubCatDeletion);
        if (rows.length === 1 && page > 1) {
          setPage(page - 1);
        } else {
          getAllCategory();
        }
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsPageLoading(true);
    getAllCategory();
  }, [page, debouncedSearchTerm]);

  const label = { inputProps: { "aria-label": "Switch demo" } };
  let totalPages = Math.ceil(totalCount / 10);
  const sensors = useSensors(useSensor(PointerSensor));

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };
  const handleReording = async (updatedItem: any) => {
    const body = {
      type: CATEGORY_TYPE.SUB_CATEGORY,
      category: updatedItem || [],
    };
    try {
      const response = await reorderMethod(body).unwrap();

      if (response?.statusCode === 200) {
        console.log("done");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      console.log(error);
    }
  };

  const handleDragEnd = (event: any) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = rows?.findIndex((item: any) => item._id === active.id);
      const newIndex = rows?.findIndex((item: any) => item._id === over.id);

      const newItems = arrayMove(rows, oldIndex, newIndex);

      // Add serialNo based on new order
      const updatedItems = newItems.map((item: any, index: number) => ({
        ...item,
        serialNo: index + 1,
      }));

      setRows(updatedItems);
      handleReording(updatedItems);
    }
  };

  return (
    <MainContainer isLoading={isPageLoading}>
      <div className="main_title">
        <h1>{translate?.main?.manageSubServices}</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>
            {translate?.dashboard?.dashboard}
          </span>{" "}
          -{" "}
          <span onClick={() => navigate("/manage-categories")}>
            {translate?.main?.manageCategories}
          </span>
          - {translate?.main?.subServices}
        </p>
      </div>

      <div className="cards">
        <Loader isLoading={isFormLoading} />
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                placeholder={translate?.user?.SearchHere}
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => {
                setName("");
                setPrice("");
                setOpen(true);
                setName_ar("");
                setSelectedId("");
                setDescription("");
                setDescription_ar("");
              }}
            >
              <AddIcon /> {"Add Sub Services"}
            </Button>
          </div>
        </div>

        <div className="sorting_table">
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={rows?.map((item: any) => item._id)}
              strategy={verticalListSortingStrategy}
            >
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th>{translate?.main?.sort}</th>
                    <th>{translate?.main?.categoryName}</th>
                    <th>{translate?.main?.startingPrice}</th>
                    <th>{translate?.main?.serviceName}</th>
                    <th>{translate?.main?.createdAt}</th>
                    <th>{translate?.main?.AddOns}</th>
                    <th>{translate?.globals?.status}</th>
                    <th>{translate?.globals?.actions}</th>
                  </tr>
                </thead>
                <tbody>
                  {rows?.length ? (
                    rows.map((row: any, index: any) => (
                      <SortableItem
                        key={row._id}
                        row={row}
                        index={index}
                        render={(item: any, dragProps: any) => (
                          <tr
                            ref={dragProps.ref}
                            style={{ ...dragProps.style }}
                          >
                            <td style={{ cursor: "grab" }}>
                              <span
                                {...dragProps.listeners}
                                {...dragProps.attributes}
                                style={{
                                  cursor: "grab",
                                  display: "inline-block",
                                  padding: "0 8px",
                                  userSelect: "none",
                                  fontSize: "30px",
                                }}
                              >
                                <img
                                  src="/static/images/dragUp.png"
                                  style={{ width: 20, height: 20 }}
                                />
                              </span>
                            </td>
                            <td>{item?.parentCategory?.name || ""}</td>
                            <td>BHD {row?.startPrice}</td>
                            <td>{item?.name || ""}</td>
                            <td>
                              {moment(item?.createdAt).format("DD MMM YYYY")}
                            </td>
                            <td>
                              <Button
                                className="btn sm btn_primary"
                                onClick={() =>
                                  navigate(
                                    `/manage-categories/services/${row?._id}/${row?.parentCategory?._id}`
                                  )
                                }
                              >
                                View
                              </Button>
                            </td>
                            <td>
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Switch
                                  {...label}
                                  size="small"
                                  checked={row?.status}
                                  onChange={() =>
                                    handleStatusChange(row?._id, !row?.status)
                                  }
                                  disabled={isLoading}
                                />
                              </Box>
                            </td>
                            <td>
                              <div className="table_actions v2">
                                <Box>
                                  <Tooltip title="View">
                                    <IconButton
                                      onClick={() => {
                                        setOpenDetails(true);
                                        setSelectedId(row?._id);
                                        setDescription(row?.description);
                                        setDescription_ar(row?.description_ar);
                                        setName(row?.name);
                                        setName_ar(row?.name_ar);
                                        setPrice(row?.startPrice);
                                      }}
                                    >
                                      <img
                                        src="/static/images/eye_icon.svg"
                                        alt=""
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                                <Box>
                                  <Tooltip title="Edit">
                                    <IconButton
                                      onClick={() => {
                                        setSelectedId(row?._id);
                                        setDescription(row?.description);
                                        setName(row?.name);
                                        setDescription_ar(row?.description_ar);
                                        setName_ar(row?.name_ar);
                                        setPrice(row?.startPrice);
                                        setOpen(true);
                                      }}
                                    >
                                      <img
                                        src="/static/images/edit2_icon.svg"
                                        alt=""
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                                <Box>
                                  <Tooltip title="Delete">
                                    <IconButton
                                      onClick={() => {
                                        setSelectedId(row?._id);
                                        setOpenDelete(true);
                                      }}
                                    >
                                      <img
                                        src="/static/images/trash2_icon.svg"
                                        alt=""
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                              </div>
                            </td>
                          </tr>
                        )}
                      />
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={8}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        {translate?.main?.noDataFound}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </SortableContext>
          </DndContext>
          {rows?.length > 0 ? (
            <Pagination
              setPage={setPage}
              module={rows}
              page={page}
              onPageChange={onPageChange}
              totalPages={totalPages}
            />
          ) : (
            ""
          )}
        </div>
      </div>
      <AddSubCategory
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        name={name}
        price={price}
        description={description}
        setName={setName}
        setDescription={setDescription}
        setPrice={setPrice}
        handleSubmit={handleSubmit}
        selectedId={selectedId}
        setSelectedId={setSelectedId}
        name_ar={name_ar}
        description_ar={description_ar}
        setName_ar={setName_ar}
        setDescription_ar={setDescription_ar}
      />
      <SubCategoryDetails
        setOpen={setOpenDetails}
        open={openDetails}
        image={image}
        price={price}
        name={name}
        onClose={handleCloseModal}
        selectedId={selectedId}
        setSelectedId={setSelectedId}
        description={description}
        name_ar={name_ar}
        description_ar={description_ar}
        setName_ar={setName_ar}
        setDescription_ar={setDescription_ar}
      />
      <ConfirmationModal
        text="Are you sure to delete this SubCategory"
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={handleDelete}
      />
    </MainContainer>
  );
};

export default ViewCategory;
